// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__57MNk","log":"ModalInventoryLogs_log__un5Si","date":"ModalInventoryLogs_date__3jIHN","userName":"ModalInventoryLogs_userName__3AA0h"};